// Banner

import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import cls from 'classnames';

import PC from '@/components/Device/PC';
import Mobile from '@/components/Device/Mobile';
import { MyContext } from '@/config/context-manager';

import styles from './style.module.scss';

const Banner = () => {
  const { t } = useTranslation('teachers');
  const { locale } = useContext(MyContext);
  return (
    <section
      className={cls(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <PC>
        <div className={styles.bg}>
          <Image src="/images/teachers/teachers-banner-bg.png" layout="fill" objectFit="cover" priority alt="" />
        </div>
      </PC>
      <div className={styles.content}>
        <div className={styles.pictureBox}>
          <div className={styles.picture}>
            <Image
              src="/images/teachers/teachers-banner-people.jpg"
              layout="fill"
              objectFit="cover"
              priority
              alt={t('师资力量-alt')}
            />
          </div>
        </div>
        <div className={styles.desBox}>
          <h1 className={styles.title}>{t('banner-标题')}</h1>
          <PC>
            <div>
              <p className={styles.subTitle}>{t('banner-副标题1')}</p>
              <p className={styles.subTitleTwo}>{t('banner-副标题2')}</p>
            </div>
          </PC>
          <Mobile>
            <div>
              <p className={styles.subTitle}>{t('banner-副标题1-移动')}</p>
              <p className={styles.subTitleTwo}>{t('banner-副标题2-移动')}</p>
            </div>
          </Mobile>
          <Mobile>
            <p className={styles.bgText}>Teachers Team</p>
          </Mobile>
        </div>
        <PC>
          <div className={styles.bgTextPc} />
        </PC>
      </div>
    </section>
  );
};

export default Banner;
